export const FLIGHT_INSPECTION_TYPES = {
    MANUAL: 1, // 人工
    SENSOR: 2, // 传感器
    MAGNETIC_COMPASS: 3, // 磁罗盘
    ROCKER: 4, // 摇杆
    ACTUATOR: 5, // 执行机构
    FLIGHT_CONFIG: 6, // 飞行配置
    PROTECTION_FUNCTION: 7, // 保护功能
    AIRSPEED_METER: 8, // 空速计
    PHOTOGRAPH: 9, // 拍照
    ACCELERATOR: 10, // 油门
    ON_SITE: 11, // 现场
}

export const flightInspectionTypes = [
    { label: '人工检查', value: FLIGHT_INSPECTION_TYPES.MANUAL },
    { label: '传感器', value: FLIGHT_INSPECTION_TYPES.SENSOR },
    { label: '磁罗盘', value: FLIGHT_INSPECTION_TYPES.MAGNETIC_COMPASS },
    { label: '摇杆', value: FLIGHT_INSPECTION_TYPES.ROCKER },
    { label: '执行机构', value: FLIGHT_INSPECTION_TYPES.ACTUATOR },
    { label: '飞行配置', value: FLIGHT_INSPECTION_TYPES.FLIGHT_CONFIG },
    // { label: '保护功能', value: FLIGHT_INSPECTION_TYPES.PROTECTION_FUNCTION },
    { label: '空速计', value: FLIGHT_INSPECTION_TYPES.AIRSPEED_METER },
    { label: '拍照', value: FLIGHT_INSPECTION_TYPES.PHOTOGRAPH },
    { label: '油门', value: FLIGHT_INSPECTION_TYPES.ACCELERATOR },
    // { label: '现场', value: FLIGHT_INSPECTION_TYPES.ON_SITE },
]

// 传感器状态
export const sensorStatus = {
    dataLink: 0,
    innerGnss: 0,
    rcLink: 0,
    outerGnss: 0,
    fcMode: 0,
    navState: 0,
}

// 磁罗盘状态列表常量
export const MAGNETIC_COMPASS_STATUS = {
    CHANNEL_1: 'compass1',
    CHANNEL_2: 'compass2',
    GNSS: 'gnss'
}

// 磁罗盘状态
export const magneticCompassStatus = {
    [MAGNETIC_COMPASS_STATUS.CHANNEL_1]: -1,
    [MAGNETIC_COMPASS_STATUS.CHANNEL_2]: -1,
    [MAGNETIC_COMPASS_STATUS.GNSS]: -1
}

// 降落方式
export const LANDING_MODES = {
    GUIDED_LANDING: 1,// 引导降落
    STANDARD_LANDING: 2,// 制式降落
}

export const landingModes = [
    {
        label: '引导降落',
        value: LANDING_MODES.GUIDED_LANDING
    },
    {
        label: '制式降落',
        value: LANDING_MODES.STANDARD_LANDING
    },
]